import React, { useEffect } from 'react';
import { TXProvider } from '@transifex/react';
import { isTransifexEnabled, initTransifex } from './transifexService';

/**
 * TransifexWrapper component.
 * If Transifex Native is enabled (currently disabled by default), wraps children
 * in TXProvider. When disabled, falls back to rendering children directly
 * under standard i18next provider.
 */
const TransifexWrapper = ({ children }) => {
  const enabled = isTransifexEnabled();

  useEffect(() => {
    initTransifex();
  }, []);

  if (enabled && process.env.REACT_APP_TRANSIFEX_TOKEN) {
    return (
      <TXProvider>
        {children}
      </TXProvider>
    );
  }

  return <>{children}</>;
};

export default TransifexWrapper;

